'use strict';

var _ = require('lodash');
var settingsData = require('../config/grid-settings.json');
var GridSelectionExampleController = function GridSelectionExampleController($scope) {
  $scope.settings = settingsData;
  $scope.featuresModelObject = {};
  $scope.newSelection = '1,2,5';
  $scope.getSelectedRows = function () {
    var selection = $scope.featuresModelObject.selection;
    return selection && selection.selectedRows || [];
  };
  $scope.getSelectedRowIndexes = function () {
    var selection = $scope.featuresModelObject.selection;
    return selection && selection.selectedRowIndexes || [];
  };
  $scope.setRowSelection = function () {
    var selection = $scope.featuresModelObject.selection;
    var forceSelection = selection && selection.setSelection;
    if (_.isFunction(forceSelection)) {
      var indexes = _.map($scope.newSelection.split(','), function (index) {
        return parseInt(index);
      });
      forceSelection(indexes);
    }
  };
};
GridSelectionExampleController.$inject = ['$scope'];
module.exports = GridSelectionExampleController;